import uPlot from 'uplot';

import type { ChartSeries } from '../_shared';

/**
 * 라인 차트 전용 spline 패스 빌더
 */
export const splinePath = uPlot.paths?.spline ? uPlot.paths.spline() : undefined;

/**
 * 라인 차트 전용 상수
 */
export const LINE_DEFAULTS = {
  /** 라인 너비 (px) */
  LINE_WIDTH: 2,
  /** 라인 곡선 정도 (0~1) */
  TENSION: 0.2,
  /** hover 시 데이터 포인트 bullet 반지름 (px) */
  BULLET_RADIUS: 4,
  /** 활성 시리즈 bullet 외곽선 두께 (px) */
  BULLET_STROKE_WIDTH: 2,
} as const;

/**
 * ChartSeries[] → uPlot.Series[] (라인 차트 전용)
 * splinePath를 사용하여 곡선 라인을 렌더링
 */
export const convertToUPlotLineSeries = (
  series: ChartSeries[],
  pathBuilder?: uPlot.Series.PathBuilder,
): uPlot.Series[] => {
  const mappedSeries: uPlot.Series[] = series.map((item) => ({
    label: item.label,
    stroke: item.color,
    width: LINE_DEFAULTS.LINE_WIDTH,
    points: {
      show: true,
      size: 8,
    },
    paths: pathBuilder,
  }));

  return [{}, ...mappedSeries];
};
